<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-05-09 11:06:59
 * @LastEditTime: 2023-04-17 15:31:51
 * @LastEditors: mdb
-->
<template>
  <router-view v-slot="slotProps">
    <dc-keep-alive :include="include" :exclude="exclude">
      <component v-if="isShow" :is="slotProps.Component" :key="route.fullPath" />
    </dc-keep-alive>
  </router-view>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { shareInfo } from '@dc-platform/dc-interaction'
import { constantRoutes } from '@/router'
import type { RouteRecordRaw } from 'vue-router'

const route = useRoute()

const include = ref<string[]>([])
const isShow = ref<boolean>(true)

// 获取不需要缓存的路由  start
const exclude = ref<string[]>([])
const getRouteNoCache = (routerList: RouteRecordRaw[]) => {
  const cacheList: string[] = []
  function getCacheList(list: RouteRecordRaw[]) {
    list.forEach((item) => {
      if (item.meta?.noCache) cacheList.push(item.name as string)
      if (item.children) getCacheList(item.children)
    })
  }
  getCacheList(routerList)
  return cacheList
}
exclude.value = getRouteNoCache(constantRoutes)
// 获取不需要缓存的路由  end

shareInfo.onKeepAliveData((data) => {
  include.value = data.include
  isShow.value = data.isShow
})
</script>
